module.exports = __webpack_public_path__ + "img/rowimage-2.a2b54bae.jpg";